import React, { useEffect } from 'react';
import '../styles/Print.css';
import Footer from '../components/Footer';

const Print = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll) - equivalent functionality
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe all elements with data-aos attribute
    const animatedElements = document.querySelectorAll('[data-aos]');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="print-page">
      {/* Hero Section with Background Image */}
      <div className="hero-section">
        {/* Background Image */}
        <div 
          className="hero-background"
          style={{
            backgroundImage: "url('/assets/Newspaper-background.jpg')"
          }}
        ></div>
        
        {/* Overlay */}
        <div className="hero-overlay"></div>
        
        {/* Hero Content */}
        <div className="hero-content">
          <div className="container">
            <div className="row align-items-center min-vh-100">
              <div className="col-12 text-center">
                <h1 className="hero-title" data-aos="fade-up" data-aos-duration="1000">
                  Newspaper Advertising Agency
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newspaper Advertisement Section */}
      <section className="newspaper-section">
        <div className="newspaper-container">
          <div className="newspaper-header">
            <h2 className="newspaper-title">
              <span className="title-part-1">Newspaper</span>
              <span className="title-part-2">Advertisement</span>
            </h2>
            <div className="title-divider"></div>
            <p className="newspaper-description">
              ARK News Advertising Agency is a dynamic media partner specializing in powerful, result-oriented advertising through news platforms. We help brands gain maximum visibility and credibility by leveraging print, digital, and electronic news media.
            </p>
          </div>
          
          <div className="newspaper-grid">
            <div className="top-row">
              <div className="newspaper-card">
                <img src="/assets/img/newspaper_ads/hindu-times.jpg" alt="The Hindu Times" className="newspaper-logo" />
                <h3 className="card-title">The Hindu Times</h3>
              </div>
              
              <div className="newspaper-card">
                <img src="/assets/img/newspaper_ads/times-of-india.png" alt="Times of India" className="newspaper-logo" />
                <h3 className="card-title">Times of India</h3>
              </div>
              
              <div className="newspaper-card">
                <img src="/assets/img/newspaper_ads/Deccan.jpg" alt="Deccan Chronicle" className="newspaper-logo" />
                <h3 className="card-title">Deccan Chronicle</h3>
              </div>
            </div>
            
            <div className="bottom-row">
              <div className="newspaper-card">
                <img src="/assets/img/newspaper_ads/hindu-tamil.jpg" alt="Hindu Tamil" className="newspaper-logo"/>
                <h3 className="card-title">Hindu Tamil</h3>
              </div>
              
              <div className="newspaper-card">
                <img src="/assets/img/newspaper_ads/kannataka-prabha.jpg" alt="Kannataka Prabha" className="newspaper-logo" />
                <h3 className="card-title">Kannataka Prabha</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Works in Newspaper Advertisement Section */}
      <section className="tv-works-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="works-title" style={{ 
                background: 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'bold'
              }}>
                Our Works in Newspaper Advertisement
              </h2>
              <div className="title-underline"></div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6">
              <div className="works-image-container">
                <img src="/assets/img/newspaper_ads/hindu-times.jpg" alt="The Hindu Times" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="works-content">
                <h3 className="works-subtitle">The Hindu Times ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising proudly collaborates with The Hindu Times to deliver impactful and result-driven advertising solutions. With a deep understanding of regional and national markets, ARK crafts compelling ad campaigns that resonate with diverse audiences.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6">
              <div className="works-content">
                <h3 className="works-subtitle">Times of India ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising offers strategic and high-impact advertising solutions in collaboration with The Times of India, one of the nation's most influential and widely read newspapers.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="works-image-container">
                <img src="/assets/img/newspaper_ads/times-of-india.png" alt="Times of India" className="works-image" />
              </div>
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6">
              <div className="works-image-container">
                <img src="/assets/img/newspaper_ads/deccan.jpg" alt="Deccan Chronicle" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="works-content">
                <h3 className="works-subtitle">Deccan Chronicle ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising partners with Deccan Chronicle to provide customized and result-oriented advertising solutions that cater to diverse regional and urban audiences.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6">
              <div className="works-content">
                <h3 className="works-subtitle">Hindu Tamil ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising offers effective and localized advertising solutions through Hindu Tamil, one of the most respected Tamil-language newspapers.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="works-image-container">
                <img src="/assets/img/newspaper_ads/hindu-tamil.jpg" alt="Hindu Tamil" className="works-image" />
              </div>
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6">
              <div className="works-image-container">
                <img src="/assets/img/newspaper_ads/kannataka-prabha.jpg" alt="Kannataka Prabha" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="works-content">
                <h3 className="works-subtitle">Kannataka Prabha ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising delivers impactful and region-specific advertising solutions through Kannada Prabha, a leading Kannada-language daily with a strong readership across Karnataka.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Print;
